import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  svg {
    color: #707070;
  }
`;

export const CompoTelefone = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const NovoCampo = styled.div`
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const CampoFlex = styled.div`
  display: flex;
  margin-top: 10px;
`;

export const Principal = styled.div`
  background-color: #262627;
`;

export const AreaDentes = styled.div`
  display: flex;
`;

export const EspacoDente1 = styled.div`
  border-bottom: 1px solid #707070;
  border-right: 1px solid #707070;
`;

export const EspacoDente2 = styled.div`
  border-bottom: 1px solid #707070;
  padding-left: 15px;
`;
export const EspacoDente3 = styled.div`
  border-right: 1px solid #707070;
`;
export const EspacoDente4 = styled.div`
  padding-left: 15px;
`;

export const TextArea = styled.textarea`
  font-size: 16px;
  padding: 5px;
  border-radius: 5px;
  width: 100%;
  padding-top: 5px;
  margin-top: 10px;
  min-height: 230px;
`;

export const EspacoFinal = styled.div`
  margin-bottom: 200px;
`;
